export default {
    state: {
        collapse: false,
    },
    getters: {
        /**
         * Retorna o estado da sidebar
         * @param state
         * @returns {boolean|((toStart?: boolean) => void)|((node: (Node | null), offset?: number) => void)}
         */
        getSidebar(state) {
            return state.collapse;
        }
    },
    mutations: {
        /**
         * Abre ou fecha a sidebar
         * @param state
         */
        toggleSidebar(state) {
            state.collapse = !state.collapse;
        },

        /**
         * Força a abertura da sidebar
         * @param state
         */
        openSidebar(state) {
            state.collapse = false;
        },

        /**
         * Força o fechamento da sidebar
         * @param state
         */
        closeSidebar(state) {
            state.collapse = true;
        }
    }

}
